import { useState } from "react";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";
import { useAxios } from "../../../utils/useAxios";

/**
 * @typedef {object} RoleOption
 * @property {string} label - Role display name
 * @property {string} value - Role value/slug
 */

/**
 * Custom hook to fetch creatable roles for member creation
 */
export const useGetCreatableRoles = () => {
    const [roles, setRoles] = useState(
    /** @type {RoleOption[] | null | undefined} */(undefined)
    );
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const { axiosInstance } = useAxios();

    /**
     * Fetch creatable roles
     */
    const getCreatableRoles = async () => {
        try {
            setLoading(true);
            setError("");

            const url = `${TENANT_DOMAIN}/references/roles/creatable`;

            const response = await axiosInstance.get(url);

            setRoles(response?.data?.data || []);
        } catch (err) {
            setRoles([]);
            if (err?.response?.status === 500) {
                setError(ERROR_MESSAGES.INTERNAL_SERVER);
            } else {
                setError(err?.response?.data?.message || ERROR_MESSAGES.UNKNOWN);
            }
        } finally {
            setLoading(false);
        }
    };

    return {
        roles,
        loading,
        error,
        getCreatableRoles,
        setRoles,
    };
};
